import ApplicationSerializer from './application';

export default class PrescreenerAnswer extends ApplicationSerializer {
  serialize(snapshot, options) {
    let json = super.serialize(snapshot, options);

    let answers = snapshot.attr('answers');
    json.data.attributes ||= {};
    json.data.attributes.answers = answers;
    return json;
  }
}
